// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const HierarchySquare2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "HierarchySquare2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841Zm.008 13.541a1.71 1.71 0 0 1-1.708-1.708c0-.55.266-1.033.675-1.35-.35-.917-1.225-1.55-2.209-1.517l-1.716.009h-.009a2.62 2.62 0 0 1-1.4-.409v1.684c.634.25 1.084.866 1.084 1.583a1.71 1.71 0 0 1-1.709 1.708A1.71 1.71 0 0 1 4.8 13.5a1.7 1.7 0 0 1 1.083-1.583V8.292A1.842 1.842 0 0 1 4.8 6.625c0-1.008.825-1.833 1.833-1.833 1.009 0 1.834.825 1.834 1.833 0 .817-.542 1.5-1.284 1.742A1.4 1.4 0 0 0 8.533 9.4h.009l1.716-.008h.017a3.61 3.61 0 0 1 3.408 2.425 1.707 1.707 0 0 1 1.534 1.691 1.722 1.722 0 0 1-1.717 1.7Z"
}));
export default HierarchySquare2Icon;